const prefetchedUrls = new Set();
const MAX_PREFETCHED_URLS = 18;

const SKIPPED_PATH_PREFIXES = ['/account', '/admin', '/apps', '/cart', '/challenge', '/checkout', '/search'];
const SKIPPED_EXTENSIONS = /\.(?:7z|avi|css|csv|docx?|gif|jpe?g|js|json|mov|mp4|pdf|png|svg|webp|xlsx?|zip)$/i;

function connectionAllowsPrefetch() {
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

  if (!connection) return true;
  if (connection.saveData) return false;

  return !['slow-2g', '2g'].includes(connection.effectiveType);
}

function getPrefetchUrl(target) {
  if (!(target instanceof Element)) return;

  const link = target.closest('a[href]');
  if (!(link instanceof HTMLAnchorElement)) return;
  if (link.download || (link.target && link.target !== '_self')) return;

  const url = new URL(link.href, window.location.href);
  if (url.origin !== window.location.origin) return;
  if (url.href === window.location.href) return;
  if (url.pathname === window.location.pathname && url.hash) return;
  if (SKIPPED_EXTENSIONS.test(url.pathname)) return;
  if (SKIPPED_PATH_PREFIXES.some((pathPrefix) => url.pathname.startsWith(pathPrefix))) return;

  for (const key of url.searchParams.keys()) {
    if (key === 'q' || key === 'page' || key === 'sort_by' || key.startsWith('filter.')) {
      return;
    }
  }

  return url;
}

function prefetchUrl(url) {
  if (!connectionAllowsPrefetch()) return;
  if (prefetchedUrls.has(url.href)) return;
  if (prefetchedUrls.size >= MAX_PREFETCHED_URLS) return;

  prefetchedUrls.add(url.href);

  const link = document.createElement('link');
  link.rel = 'prefetch';
  link.as = 'document';
  link.href = url.href;
  link.setAttribute('fetchpriority', 'low');
  document.head.appendChild(link);
}

function handlePotentialNavigation(event) {
  if (
    typeof PointerEvent !== 'undefined' &&
    event instanceof PointerEvent &&
    event.pointerType !== 'mouse' &&
    event.pointerType !== 'pen'
  ) {
    return;
  }

  const url = getPrefetchUrl(event.target);
  if (!url) return;

  prefetchUrl(url);
}

document.addEventListener('pointerover', handlePotentialNavigation, { capture: true, passive: true });
document.addEventListener('focusin', handlePotentialNavigation, { capture: true });
document.addEventListener('touchstart', handlePotentialNavigation, { capture: true, passive: true });
